import { render, staticRenderFns } from "./management-announcement-view.vue?vue&type=template&id=ba56347e"
import script from "./management-announcement-view.vue?vue&type=script&lang=js"
export * from "./management-announcement-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports